// extracted by mini-css-extract-plugin
export default {"cls1":"PodcastLibraryAd1-cls1_DUC","cls2":"PodcastLibraryAd1-cls2_sp8 PodcastLibraryAd1-cls1_DUC"};